import ForgotForm from "components/login/ForgotForm";
import LoginForm from "components/login/LoginForm";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { loginAction } from "store/action-creators/login";
import loginImage from "assets/images/login-image.svg";
import logo from "assets/images/logo.svg";
import {
  getAccessToken,
  getUserInfo,
  roleAccessRules,
  setAccessToken,
  setRefreshToken,
  setTokenCreatedAt,
  setTokenExpiresIn,
  setUserInfoInStorage,
  useQuery,
} from "utils/common";
import "./login.scss";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery();
  const shouldResetPassword = query.get("reset");
  const [checked, setCheck] = useState(false);

  useEffect(() => {
    if (getAccessToken()) {
      navigate("/members");
    }
  }, [navigate]);
  const handleCheckChange = () => {
    setCheck(!checked);
  };
  const loginFormSubmitHandler = async (values, setErrors, setSubmitting) => {
    const response = await dispatch(loginAction(values, setSubmitting));
    if (response?.status_code === 200) {
      setAccessToken(response.access_token);
      setRefreshToken(response.refresh_token);
      setTokenCreatedAt(response.created_at);
      setTokenExpiresIn(response.expires_in);

      setUserInfoInStorage(response.result);

      let route_to_navigate = "/members";
      route_to_navigate = roleAccessRules[response?.result.type][0];
      console.log("navigate to ", route_to_navigate);
      navigate(route_to_navigate);
    }
  };
  return (
    <div className="Login-main">
      <div className="logo mt-4">
        <img src={logo} />
      </div>
      <div className="col-login-otr">
        <img src={loginImage} alt="icon" className="login-section" />
        <div className="col-login-inr">
          {shouldResetPassword ? (
            <ForgotForm />
          ) : (
            <LoginForm
              checked={checked}
              handleCheckChange={handleCheckChange}
              formSubmitHandler={loginFormSubmitHandler}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
